import { Flex, Typography, Button } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { MenuRowCard } from './MenuRowModal';

type ProductsCardProps = {
  readonly onAddProductsClick: () => void;
  readonly productsTable: ReactNode;
  readonly productStockCounts: {
    inStock: number;
    outOfStock: number;
  };
  readonly shouldShowAddProducts?: boolean;
};

export const ProductsCard = ({
  productStockCounts: productCounts,
  shouldShowAddProducts = false,
  onAddProductsClick,
  productsTable,
}: ProductsCardProps) => (
  <MenuRowCard data-testid="products-card">
    <Flex flexDirection="column">
      <Flex mb={32} justifyContent="space-between" alignItems="center">
        <Flex flexDirection="column">
          <Typography variant="header-bold" branded>
            Products
          </Typography>
          <Typography variant="body" mt={8}>
            {`${productCounts.inStock} in-stock, `}
            {`${productCounts.outOfStock} out-of-stock`}
          </Typography>
        </Flex>
        {shouldShowAddProducts ? (
          <Button
            variant="secondary"
            label="Add Products"
            onClick={() => onAddProductsClick()}
          />
        ) : null}
      </Flex>
      {productsTable}
    </Flex>
  </MenuRowCard>
);
